const swarmplotdata = [
    {
        "id": "0.0",
        "group": "group C",
        "price": 337,
        "volume": 6
    },
    {
        "id": "0.1",
        "group": "group B",
        "price": 233,
        "volume": 10
    },
    {
        "id": "0.2",
        "group": "group C",
        "price": 418,
        "volume": 9
    },
    {
        "id": "0.3",
        "group": "group C",
        "price": 37,
        "volume": 20
    },
    {
        "id": "0.4",
        "group": "group C",
        "price": 40,
        "volume": 5
    },
    {
        "id": "0.5",
        "group": "group A",
        "price": 475,
        "volume": 9
    },
    {
        "id": "0.6",
        "group": "group C",
        "price": 345,
        "volume": 6
    },
    {
        "id": "0.7",
        "group": "group A",
        "price": 396,
        "volume": 7
    },
    {
        "id": "0.8",
        "group": "group C",
        "price": 200,
        "volume": 20
    },
    {
        "id": "0.9",
        "group": "group C",
        "price": 279,
        "volume": 19
    },
    {
        "id": "0.10",
        "group": "group C",
        "price": 254,
        "volume": 14
    },
    {
        "id": "0.11",
        "group": "group A",
        "price": 345,
        "volume": 16
    },
    {
        "id": "0.12",
        "group": "group C",
        "price": 431,
        "volume": 17
    },
    {
        "id": "0.13",
        "group": "group C",
        "price": 115,
        "volume": 14
    },
    {
        "id": "0.14",
        "group": "group C",
        "price": 464,
        "volume": 6
    },
    {
        "id": "0.15",
        "group": "group B",
        "price": 18,
        "volume": 17
    },
    {
        "id": "0.16",
        "group": "group B",
        "price": 81,
        "volume": 15
    },
    {
        "id": "0.17",
        "group": "group A",
        "price": 132,
        "volume": 12
    },
    {
        "id": "0.18",
        "group": "group C",
        "price": 298,
        "volume": 6
    },
    {
        "id": "0.19",
        "group": "group B",
        "price": 152,
        "volume": 16
    },
    {
        "id": "0.20",
        "group": "group A",
        "price": 270,
        "volume": 14
    },
    {
        "id": "0.21",
        "group": "group A",
        "price": 243,
        "volume": 8
    },
    {
        "id": "0.22",
        "group": "group C",
        "price": 88,
        "volume": 10
    },
    {
        "id": "0.23",
        "group": "group C",
        "price": 215,
        "volume": 10
    },
    {
        "id": "0.24",
        "group": "group B",
        "price": 29,
        "volume": 16
    },
    {
        "id": "0.25",
        "group": "group B",
        "price": 412,
        "volume": 10
    },
    {
        "id": "0.26",
        "group": "group C",
        "price": 483,
        "volume": 10
    },
    {
        "id": "0.27",
        "group": "group B",
        "price": 320,
        "volume": 17
    },
    {
        "id": "0.28",
        "group": "group C",
        "price": 232,
        "volume": 20
    },
    {
        "id": "0.29",
        "group": "group A",
        "price": 223,
        "volume": 12
    },
    {
        "id": "0.30",
        "group": "group B",
        "price": 58,
        "volume": 10
    },
    {
        "id": "0.31",
        "group": "group B",
        "price": 183,
        "volume": 19
    },
    {
        "id": "0.32",
        "group": "group B",
        "price": 492,
        "volume": 9
    },
    {
        "id": "0.33",
        "group": "group C",
        "price": 34,
        "volume": 13
    },
    {
        "id": "0.34",
        "group": "group A",
        "price": 62,
        "volume": 12
    },
    {
        "id": "0.35",
        "group": "group A",
        "price": 75,
        "volume": 6
    },
    {
        "id": "0.36",
        "group": "group C",
        "price": 424,
        "volume": 19
    },
    {
        "id": "0.37",
        "group": "group B",
        "price": 229,
        "volume": 11
    },
    {
        "id": "0.38",
        "group": "group B",
        "price": 288,
        "volume": 6
    },
    {
        "id": "0.39",
        "group": "group A",
        "price": 135,
        "volume": 5
    },
    {
        "id": "0.40",
        "group": "group A",
        "price": 495,
        "volume": 6
    },
    {
        "id": "0.41",
        "group": "group B",
        "price": 82,
        "volume": 17
    },
    {
        "id": "0.42",
        "group": "group C",
        "price": 323,
        "volume": 13
    },
    {
        "id": "0.43",
        "group": "group C",
        "price": 453,
        "volume": 16
    },
    {
        "id": "0.44",
        "group": "group A",
        "price": 367,
        "volume": 10
    },
    {
        "id": "0.45",
        "group": "group A",
        "price": 239,
        "volume": 16
    },
    {
        "id": "0.46",
        "group": "group C",
        "price": 300,
        "volume": 11
    },
    {
        "id": "0.47",
        "group": "group A",
        "price": 354,
        "volume": 13
    },
    {
        "id": "0.48",
        "group": "group B",
        "price": 107,
        "volume": 13
    },
    {
        "id": "0.49",
        "group": "group B",
        "price": 151,
        "volume": 8
    },
    {
        "id": "0.50",
        "group": "group A",
        "price": 492,
        "volume": 17
    },
    {
        "id": "0.51",
        "group": "group C",
        "price": 7,
        "volume": 17
    },
    {
        "id": "0.52",
        "group": "group A",
        "price": 42,
        "volume": 16
    },
    {
        "id": "0.53",
        "group": "group B",
        "price": 450,
        "volume": 16
    },
    {
        "id": "0.54",
        "group": "group C",
        "price": 125,
        "volume": 19
    },
    {
        "id": "1.0",
        "group": "group A",
        "price": 488,
        "volume": 13
    },
    {
        "id": "1.1",
        "group": "group B",
        "price": 83,
        "volume": 8
    },
    {
        "id": "1.2",
        "group": "group A",
        "price": 330,
        "volume": 18
    },
    {
        "id": "1.3",
        "group": "group C",
        "price": 230,
        "volume": 7
    },
    {
        "id": "1.4",
        "group": "group C",
        "price": 64,
        "volume": 11
    },
    {
        "id": "1.5",
        "group": "group A",
        "price": 62,
        "volume": 7
    },
    {
        "id": "1.6",
        "group": "group A",
        "price": 182,
        "volume": 12
    },
    {
        "id": "1.7",
        "group": "group A",
        "price": 100,
        "volume": 9
    },
    {
        "id": "1.8",
        "group": "group C",
        "price": 136,
        "volume": 14
    },
    {
        "id": "1.9",
        "group": "group C",
        "price": 107,
        "volume": 15
    },
    {
        "id": "1.10",
        "group": "group B",
        "price": 209,
        "volume": 20
    },
    {
        "id": "1.11",
        "group": "group A",
        "price": 80,
        "volume": 13
    },
    {
        "id": "1.12",
        "group": "group B",
        "price": 399,
        "volume": 10
    },
    {
        "id": "1.13",
        "group": "group C",
        "price": 324,
        "volume": 16
    },
    {
        "id": "1.14",
        "group": "group A",
        "price": 143,
        "volume": 9
    },
    {
        "id": "1.15",
        "group": "group A",
        "price": 408,
        "volume": 16
    },
    {
        "id": "1.16",
        "group": "group B",
        "price": 234,
        "volume": 4
    },
    {
        "id": "1.17",
        "group": "group B",
        "price": 360,
        "volume": 4
    },
    {
        "id": "1.18",
        "group": "group B",
        "price": 22,
        "volume": 15
    },
    {
        "id": "1.19",
        "group": "group A",
        "price": 305,
        "volume": 9
    },
    {
        "id": "1.20",
        "group": "group A",
        "price": 64,
        "volume": 9
    },
    {
        "id": "1.21",
        "group": "group B",
        "price": 356,
        "volume": 10
    },
    {
        "id": "1.22",
        "group": "group A",
        "price": 174,
        "volume": 5
    },
    {
        "id": "1.23",
        "group": "group C",
        "price": 283,
        "volume": 4
    },
    {
        "id": "1.24",
        "group": "group A",
        "price": 24,
        "volume": 14
    },
    {
        "id": "1.25",
        "group": "group B",
        "price": 38,
        "volume": 8
    },
    {
        "id": "1.26",
        "group": "group B",
        "price": 195,
        "volume": 13
    },
    {
        "id": "1.27",
        "group": "group B",
        "price": 72,
        "volume": 11
    },
    {
        "id": "1.28",
        "group": "group B",
        "price": 266,
        "volume": 7
    },
    {
        "id": "1.29",
        "group": "group B",
        "price": 230,
        "volume": 13
    },
    {
        "id": "1.30",
        "group": "group B",
        "price": 298,
        "volume": 17
    },
    {
        "id": "1.31",
        "group": "group B",
        "price": 195,
        "volume": 10
    },
    {
        "id": "1.32",
        "group": "group A",
        "price": 161,
        "volume": 6
    },
    {
        "id": "1.33",
        "group": "group A",
        "price": 458,
        "volume": 16
    },
    {
        "id": "1.34",
        "group": "group C",
        "price": 43,
        "volume": 11
    },
    {
        "id": "1.35",
        "group": "group B",
        "price": 481,
        "volume": 4
    },
    {
        "id": "1.36",
        "group": "group B",
        "price": 137,
        "volume": 19
    },
    {
        "id": "1.37",
        "group": "group A",
        "price": 37,
        "volume": 20
    },
    {
        "id": "1.38",
        "group": "group C",
        "price": 201,
        "volume": 16
    },
    {
        "id": "1.39",
        "group": "group B",
        "price": 452,
        "volume": 12
    },
    {
        "id": "1.40",
        "group": "group A",
        "price": 170,
        "volume": 6
    },
    {
        "id": "1.41",
        "group": "group B",
        "price": 257,
        "volume": 18
    },
    {
        "id": "1.42",
        "group": "group C",
        "price": 430,
        "volume": 7
    },
    {
        "id": "1.43",
        "group": "group A",
        "price": 55,
        "volume": 15
    },
    {
        "id": "1.44",
        "group": "group B",
        "price": 460,
        "volume": 7
    },
    {
        "id": "1.45",
        "group": "group C",
        "price": 111,
        "volume": 15
    },
    {
        "id": "1.46",
        "group": "group B",
        "price": 44,
        "volume": 13
    },
    {
        "id": "1.47",
        "group": "group A",
        "price": 395,
        "volume": 19
    },
    {
        "id": "1.48",
        "group": "group A",
        "price": 456,
        "volume": 7
    },
    {
        "id": "1.49",
        "group": "group A",
        "price": 450,
        "volume": 19
    },
    {
        "id": "1.50",
        "group": "group A",
        "price": 37,
        "volume": 4
    },
    {
        "id": "1.51",
        "group": "group B",
        "price": 257,
        "volume": 12
    },
    {
        "id": "1.52",
        "group": "group B",
        "price": 398,
        "volume": 4
    },
    {
        "id": "1.53",
        "group": "group A",
        "price": 443,
        "volume": 5
    },
    {
        "id": "1.54",
        "group": "group A",
        "price": 156,
        "volume": 11
    },
    {
        "id": "1.55",
        "group": "group A",
        "price": 334,
        "volume": 11
    },
    {
        "id": "1.56",
        "group": "group B",
        "price": 458,
        "volume": 15
    },
    {
        "id": "1.57",
        "group": "group C",
        "price": 425,
        "volume": 9
    },
    {
        "id": "2.0",
        "group": "group A",
        "price": 55,
        "volume": 9
    },
    {
        "id": "2.1",
        "group": "group B",
        "price": 482,
        "volume": 12
    },
    {
        "id": "2.2",
        "group": "group B",
        "price": 403,
        "volume": 4
    },
    {
        "id": "2.3",
        "group": "group B",
        "price": 133,
        "volume": 7
    },
    {
        "id": "2.4",
        "group": "group B",
        "price": 294,
        "volume": 9
    },
    {
        "id": "2.5",
        "group": "group A",
        "price": 410,
        "volume": 20
    },
    {
        "id": "2.6",
        "group": "group A",
        "price": 317,
        "volume": 4
    },
    {
        "id": "2.7",
        "group": "group A",
        "price": 179,
        "volume": 8
    },
    {
        "id": "2.8",
        "group": "group C",
        "price": 306,
        "volume": 17
    },
    {
        "id": "2.9",
        "group": "group B",
        "price": 233,
        "volume": 18
    },
    {
        "id": "2.10",
        "group": "group C",
        "price": 121,
        "volume": 6
    },
    {
        "id": "2.11",
        "group": "group B",
        "price": 489,
        "volume": 15
    },
    {
        "id": "2.12",
        "group": "group A",
        "price": 499,
        "volume": 7
    },
    {
        "id": "2.13",
        "group": "group C",
        "price": 287,
        "volume": 17
    },
    {
        "id": "2.14",
        "group": "group C",
        "price": 433,
        "volume": 19
    },
    {
        "id": "2.15",
        "group": "group A",
        "price": 412,
        "volume": 5
    },
    {
        "id": "2.16",
        "group": "group C",
        "price": 420,
        "volume": 5
    },
    {
        "id": "2.17",
        "group": "group C",
        "price": 496,
        "volume": 16
    },
    {
        "id": "2.18",
        "group": "group A",
        "price": 416,
        "volume": 10
    },
    {
        "id": "2.19",
        "group": "group A",
        "price": 308,
        "volume": 4
    },
    {
        "id": "2.20",
        "group": "group B",
        "price": 370,
        "volume": 17
    },
    {
        "id": "2.21",
        "group": "group A",
        "price": 163,
        "volume": 16
    },
    {
        "id": "2.22",
        "group": "group A",
        "price": 432,
        "volume": 12
    },
    {
        "id": "2.23",
        "group": "group A",
        "price": 206,
        "volume": 16
    },
    {
        "id": "2.24",
        "group": "group A",
        "price": 294,
        "volume": 13
    },
    {
        "id": "2.25",
        "group": "group A",
        "price": 189,
        "volume": 11
    },
    {
        "id": "2.26",
        "group": "group C",
        "price": 170,
        "volume": 19
    },
    {
        "id": "2.27",
        "group": "group B",
        "price": 474,
        "volume": 13
    },
    {
        "id": "2.28",
        "group": "group C",
        "price": 104,
        "volume": 13
    },
    {
        "id": "2.29",
        "group": "group A",
        "price": 280,
        "volume": 15
    },
    {
        "id": "2.30",
        "group": "group A",
        "price": 319,
        "volume": 16
    },
    {
        "id": "2.31",
        "group": "group B",
        "price": 222,
        "volume": 15
    },
    {
        "id": "2.32",
        "group": "group B",
        "price": 146,
        "volume": 18
    },
    {
        "id": "2.33",
        "group": "group B",
        "price": 205,
        "volume": 6
    },
    {
        "id": "2.34",
        "group": "group A",
        "price": 341,
        "volume": 11
    },
    {
        "id": "2.35",
        "group": "group C",
        "price": 268,
        "volume": 6
    },
    {
        "id": "2.36",
        "group": "group B",
        "price": 266,
        "volume": 5
    },
    {
        "id": "2.37",
        "group": "group B",
        "price": 227,
        "volume": 4
    },
    {
        "id": "2.38",
        "group": "group B",
        "price": 370,
        "volume": 15
    },
    {
        "id": "2.39",
        "group": "group A",
        "price": 212,
        "volume": 5
    },
    {
        "id": "2.40",
        "group": "group B",
        "price": 17,
        "volume": 9
    },
    {
        "id": "2.41",
        "group": "group C",
        "price": 87,
        "volume": 7
    },
    {
        "id": "2.42",
        "group": "group A",
        "price": 58,
        "volume": 13
    },
    {
        "id": "2.43",
        "group": "group A",
        "price": 312,
        "volume": 16
    },
    {
        "id": "2.44",
        "group": "group A",
        "price": 170,
        "volume": 13
    },
    {
        "id": "2.45",
        "group": "group B",
        "price": 155,
        "volume": 8
    },
    {
        "id": "2.46",
        "group": "group C",
        "price": 286,
        "volume": 11
    },
    {
        "id": "2.47",
        "group": "group B",
        "price": 372,
        "volume": 7
    },
    {
        "id": "2.48",
        "group": "group B",
        "price": 478,
        "volume": 12
    },
    {
        "id": "2.49",
        "group": "group B",
        "price": 77,
        "volume": 4
    },
    {
        "id": "2.50",
        "group": "group A",
        "price": 224,
        "volume": 20
    },
    {
        "id": "2.51",
        "group": "group C",
        "price": 244,
        "volume": 11
    },
    {
        "id": "2.52",
        "group": "group C",
        "price": 244,
        "volume": 14
    },
    {
        "id": "2.53",
        "group": "group A",
        "price": 195,
        "volume": 5
    },
    {
        "id": "2.54",
        "group": "group C",
        "price": 56,
        "volume": 17
    },
    {
        "id": "2.55",
        "group": "group B",
        "price": 492,
        "volume": 6
    },
    {
        "id": "2.56",
        "group": "group A",
        "price": 239,
        "volume": 7
    },
    {
        "id": "2.57",
        "group": "group A",
        "price": 488,
        "volume": 7
    },
    {
        "id": "2.58",
        "group": "group C",
        "price": 13,
        "volume": 5
    }
]
export default swarmplotdata